import React, { useState } from "react";
import { Button } from "antd";
import {
  DisplaysProposal,
  BudgetProposal,
  DatesProposal,
  CampaignTypeProposal,
  ClientProposal,
  BrandProposal,
  ExternalDspProposal,
} from "./proposals";

function ProposalCard({ proposal, action, onConfirm, onReject, loading, disabled, t }) {
  const payload = proposal && proposal.payload;

  const [checkedIds, setCheckedIds] = useState(() => {
    if (
      (action === 'add_displays' || action === 'delete_displays') &&
      payload && payload.display_ids
    ) {
      return [...payload.display_ids];
    }
    return null;
  });

  const toggleId = id =>
    setCheckedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );

  const handleConfirm = () => onConfirm(action, true, checkedIds);
  const handleReject  = () => onReject(action);

  const renderBody = () => {
    if (!payload) return null;

    switch (action) {
      case 'add_displays':
        return (
          <DisplaysProposal
            action={action}
            payload={payload}
            checkedIds={checkedIds}
            onToggle={toggleId}
            disabled={disabled}
            t={t}
          />
        );
      case 'delete_displays':
        return (
          <DisplaysProposal
            action={action}
            payload={payload}
            checkedIds={checkedIds}
            onToggle={toggleId}
            disabled={disabled}
            t={t}
          />
        );
      case 'update_campaign_budget':
        return <BudgetProposal payload={payload} t={t} />;
      case 'update_campaign_dates':
        return <DatesProposal payload={payload} t={t} />;
      case 'change_campaign_type':
        return <CampaignTypeProposal payload={payload} t={t} />;
      case 'change_client':
        return <ClientProposal payload={payload} t={t} />;
      case 'change_brand':
        return <BrandProposal payload={payload} t={t} />;
      case 'change_external_dsp':
        return <ExternalDspProposal payload={payload} t={t} />;
      default:
        return null;
    }
  };

  const locked = disabled || loading;
  const disabledConfirm = locked ||
    (checkedIds !== null && checkedIds.length === 0);

  return (
    <div
      className={
        disabled
          ? "chatbot-proposal-card chatbot-proposal-card--resolved"
          : "chatbot-proposal-card"
      }
    >
      {renderBody()}
      <div className="chatbot-proposal-actions">
        <Button
          size="small"
          onClick={handleReject}
          disabled={locked}
          className="chatbot-proposal-btn-reject"
        >
          {t('ChatbotReject')}
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={handleConfirm}
          disabled={disabledConfirm}
          loading={loading && !disabled}
          className="chatbot-proposal-btn-confirm"
        >
          {t('ChatbotConfirm')}
        </Button>
      </div>
    </div>
  );
}

export default ProposalCard;
